<ul class="nav main-menu menu navbar-nav">
  <li *ngFor="let item of navigation">
    <a (click)="outClickedItem.emit(item)" [routerLinkActive]="item.url">
    {{ 'MENU.' + item.label | translate }}
    </a>
  </li>
</ul>